var BillingInformationRelayer = function (tokenRepository, iframeMessenger) {
    return {
        listenForMessagesAndRelayToTokenService: function () {
            iframeMessenger.listen(function(message){
                var data = JSON.parse(message);
                return tokenRepository.create(data['requestData'], data['authToken']);
            });
        }
    }
};

module.exports = BillingInformationRelayer;
